var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66892 4.11328C10.1104 4.54538 10.1104 5.24382 9.66892 5.67592C9.22749 6.10803 8.51397 6.10803 8.07254 5.67592L4.99944 2.66777L1.92746 5.67592C1.48603 6.10803 0.77138 6.10803 0.331076 5.67592C-0.110358 5.24382 -0.110358 4.54538 0.331076 4.11328L4.20124 0.323802C4.42252 0.108302 4.71041 0 4.99944 0C5.28846 0 5.57748 0.108302 5.79763 0.323802L9.66892 4.11328Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.a7cc27d7.svg";
export { ForwardRef as ReactComponent };